module.exports = __webpack_public_path__ + "static/media/DSC_2689-HDR.86153bfb.jpg";